import { Value } from '@/component/Value';
import { formatDateAndTime } from '@/util/date';
import {
  DateRangeColumnFilter,
  dateRangeFilterFn,
} from './filter/DateRangeColumnFilter';
import { NumberColumnFilter } from './filter/NumberColumnFilter';
import type { DataType, ExtendedColumnDef } from './types';

type DataTypeConfig = Partial<ExtendedColumnDef<any>>;

const config: Record<DataType, DataTypeConfig> = {
  date: {
    Filter: DateRangeColumnFilter,
    filterFn: dateRangeFilterFn,
    sortingFn: 'datetime',
    sortUndefined: -1,
    meta: {
      filterLabel: (filterValue) => {
        if (!Array.isArray(filterValue)) {
          return '';
        }
        const [f, t] = filterValue;
        if (typeof f !== 'number' || typeof t !== 'number') {
          return '';
        }
        const from = new Date(f);
        const to = new Date(t);

        return [formatDateAndTime(from), formatDateAndTime(to)].join(' ... ');
      },
    },
  },
  number: {
    Filter: NumberColumnFilter,
    filterFn: 'inNumberRange',
    cell: ({ getValue }) => <Value value={getValue()} />,
    sortUndefined: -1,
    meta: {
      enableAggregations: true,
    },
  },
};

export function getColumnDefaults(dataType: DataType | undefined) {
  if (dataType === undefined) {
    return null;
  }
  return config[dataType];
}
